import { View } from "binder"
import { OPCManipulationViewModel, OPC } from "./opcManipulation-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class OPCManipulationView extends View<OPCManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-2E06CD09-D3D2-4172-97F5-54B7DE9A05A9"
    }
    loadHtml(): string {
        let element = require('./opcManipulation.html').default;
        let style = require('./opcManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set opcs(v: OPC) { this._opcs = v; } public get opcs(): OPC { return this._opcs; } private _opcs: OPC;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
